import React, { FC, useCallback } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { Button, Box } from '@mui/material'
import { toast } from 'react-toastify'
import { useRest, useRefresh } from '../../components/Context'
import { ReactComponent as CSVFileImg } from '../../assets/icons/csv-file-icon.svg'

interface IUploadCsvFile {
  type: string
}

interface IUploadedFileResponse {
  success: boolean
  message: string
  // eslint-disable-next-line
  errors: any
  createdItems: number
  updatedItems: number
}

type FormInputs = {
  docType: string
  file: File
  comment?: string
}

export const UploadCsvFile: FC<IUploadCsvFile> = ({ type }) => {
  const formMethods = useForm<FormInputs>({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })
  const { rxiosUpload } = useRest()
  const { saveIsRefresh } = useRefresh()

  // eslint-disable-next-line
  const ErrorToastBody = (errors: any, createdItems: number, updatedItems: number) => {
    return (
      <Box>
        <Box>
          {createdItems > 0 || updatedItems > 0 ? (
            <span>{`Created: ${createdItems}, Updated: ${updatedItems}`}</span>
          ) : null}
          <p>Uploaded with errors:</p>
          {errors &&
            // eslint-disable-next-line
            errors.map((error: any, index: number) => (
              <Box key={index}>
                <span>{`${index + 1}.  ${error.name}: ${error.message}`}</span>
              </Box>
            ))}
        </Box>
      </Box>
    )
  }

  const SuccessToastBody = (message: string, createdItems: number, updatedItems: number) => {
    return (
      <Box>
        <Box>
          <span>{message}</span>
        </Box>
        <Box>
          <span>{(createdItems > 0 || updatedItems > 0) && `Created: ${createdItems}, Updated: ${updatedItems}`}</span>
        </Box>
      </Box>
    )
  }

  const handleFileChange = useCallback(
    // eslint-disable-next-line
    (e: any) => {
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('type', type)

      // eslint-disable-next-line
      rxiosUpload.post<IUploadedFileResponse>('upload-csv-file', formData).subscribe({
        next: (response) => {
          if (response) {
            formMethods.reset()
            saveIsRefresh(true)
            if (response?.errors?.length > 0) {
              toast.error(ErrorToastBody(response.errors, response.createdItems, response.updatedItems), {
                autoClose: false,
              })
            } else {
              toast.success(SuccessToastBody(response.message, response.createdItems, response.updatedItems))
            }
          }
        },
        error: (err) => {
          toast.error(err?.response?.data.message)
        },
      })
    },
    [rxiosUpload, saveIsRefresh, type, formMethods],
  )

  return (
    <FormProvider {...formMethods}>
      <Button color="primary" component="label">
        <CSVFileImg />
        <input type="file" accept="text/csv" name="file" hidden onChange={handleFileChange} required />
      </Button>
    </FormProvider>
  )
}
